import styled from "styled-components";

export const Wrapper = styled.div`
.ant-upload-wrapper.ant-upload-picture-card-wrapper .ant-upload.ant-upload-select, .ant-upload-wrapper.ant-upload-picture-circle-wrapper .ant-upload.ant-upload-select{
    width: 72px !important;
    height: 72px !important;
}
.ant-upload-wrapper {text-align:right}
.ant-upload-wrapper.ant-upload-picture-card-wrapper .ant-upload.ant-upload-select:not(.ant-upload-disabled):hover, .ant-upload-wrapper.ant-upload-picture-circle-wrapper .ant-upload.ant-upload-select:not(.ant-upload-disabled):hover {
    border-color:rgb(255, 0, 0);
}
`;